import React, { useEffect } from 'react';
import { Table } from 'reactstrap';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { API_PATIENT_DIAGNOSES } from 'services/dataService/ccmResources';
import Pagination from 'components/molecules/paginationTransition';
import useTable from 'utils/useTable';
import { useParams } from 'react-router-dom';

const PER_PAGE = 5;

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:s';

const Conditions = () => {
  const { patientGuid } = useParams();
  const dates = useSelector((state) => state.ccmPatientDetails.dates);

  const {
    data: { items },
    count,
    page,
    setPage,
    setFilters,
  } = useTable(API_PATIENT_DIAGNOSES, PER_PAGE, { patientGuid });

  useEffect(() => {
    if (dates.length > 1) {
      const startTime = format(dates[0], DATE_FORMAT);
      const endTime = format(dates[1], DATE_FORMAT);
      setFilters({ patientGuid, startTime, endTime });
    }
  }, [dates, patientGuid]);

  return (
    <>
      <h3 className="ccm-table-section__h4">Conditions</h3>
      <Table borderless border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th>ICD-10</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {!!items.length &&
            items.map((el, index) => (
              <>
                <tr key={index}>
                  <td>{el.icdCode?.code}</td>
                  <td>{el.description}</td>
                </tr>
              </>
            ))}
        </tbody>
      </Table>

      {!!items.length && (
        <Pagination
          title=""
          page={page}
          pageTotal={items.length}
          itemsPerPage={PER_PAGE}
          total={count}
          handleFirstClick={() => setPage(1)}
          handleLastClick={() => setPage(Math.ceil(count / PER_PAGE))}
          handlePrevClick={() => setPage(page - 1)}
          handleNextClick={() => setPage(page + 1)}
          handleGoToPage={(numberPage) => setPage(numberPage)}
        />
      )}
    </>
  );
};

export default Conditions;
